import { useCallback, useRef } from "react"

import { debounce } from "@mui/material"
import { FormState } from "final-form"

export const useDebouncedFields = () => {
  const lastDirtyValuesRef = useRef({})

  const handleDebouncedCallback = useCallback(
    debounce((callback) => callback(), 2000),
    []
  )

  const debouncedFieldsChanged = (props: FormState<any>, debouncedFields = []) =>
    debouncedFields
      .some((field) =>
        props.dirtyFields[field]
        && lastDirtyValuesRef.current[field] !== props.values[field]
      )

  const handleDebouncedChange = (
    callback: () => void,
    props: FormState<any>,
    debouncedFields: string[] = []
  ) => {

    debouncedFields
      .filter((field) => props.dirtyFields[field])
      .filter((field) => lastDirtyValuesRef.current[field] !== props.values[field])
      .forEach((field) => lastDirtyValuesRef.current[field] = props.values[field])

    handleDebouncedCallback(callback)
  }

  return {
    debouncedFieldsChanged,
    handleDebouncedChange
  }
}
